export default {
  button: {
    add: 'Thêm',
    modify: 'Sửa',
    delete: 'Xóa',
    cancel: 'Hủy',
    save: 'Lưu',
    create: 'Tạo mới',
    update: 'Cập nhật',
    search: 'Tìm kiếm',
    newRequest: 'Yêu cầu mới',
    receive: 'Tiếp nhận',
    reject: 'Từ chối',
    complete: 'Hoàn thành',
    downloadExcel: 'Xuất Excel',
    copy: 'Sao chép',
    resetPassword: 'Đặt lại mật khẩu',
    uploadFromExcel: 'Nhập từ Excel',
    addTransactionCode: 'Thêm mã GD',
    modifyTransactionCode: 'Sửa mã GD',
    deleteTransactionCode: 'Xóa mã GD',
    addSubTransactionCode: 'Thêm mã GD phụ',
    modifySubTransactionCode: 'Sửa mã GD phụ',
    deleteSubTransactionCode: 'Xóa mã GD phụ',
    changeAllSubTransaction: 'Thay đổi tất cả GD phụ',
    addConfiguration: 'Thêm cấu hình',
    modifyConfiguration: 'Sửa cấu hình',
    deleteConfiguration: 'Xóa cấu hình',
    addCategory: 'Thêm danh mục',
    modifyCategory: 'Sửa danh mục',
    deleteCategory: 'Xóa danh mục',
    addPackage: 'Thêm gói',
    modifyPackage: 'Sửa gói',
    deletePackage: 'Xóa gói',
    addPackageDetail: 'Thêm chi tiết gói',
    modifyPackageDetail: 'Sửa chi tiết gói',
    deletePackageDetail: 'Xóa chi tiết gói',
    menuAuthorization: 'Phân quyền Menu',
    display: 'Hiển thị',
    priceTypeUpdate: 'Sửa loại giá',
    addPriceCode: 'Thêm mã giá',
    modifyPriceCode: 'Sửa mã giá',
    deletePriceCode: 'Xóa mã giá',
    exit: 'Thoát',
    stay: 'Ở lại',
    addGroup: 'Thêm nhóm',
    modifyGroup: 'Sửa nhóm',
    deleteGroup: 'Xóa nhóm',
    attachService: 'Gán dịch vụ',
    addCode: 'Thêm mã',
    modifyCode: 'Sửa mã',
    deleteCode: 'Xóa mã',
    addService: 'Thêm dịch vụ',
    modifyService: 'Sửa dịch vụ',
    deleteService: 'Xóa dịch vụ',
    addSurcharge: 'Thêm phụ thu',
    modifySurcharge: 'Sửa phụ thu',
    deleteSurcharge: 'Xóa phụ thu',
    detail: 'Chi tiết',
    dirtyRoom: 'Phòng bẩn',
    dirty: 'Bẩn',
    clean: 'Sạch',
    checked: 'Đã kiểm tra',
    lightClean: 'Dọn sơ qua',
    empty: 'Trống',
    occupied: 'Có khách',
    roomTaskAssignment: 'Phân công dọn phòng',
    staffMng: 'Quản lý NV',
    downloadTemplate: 'Tải mẫu',
    setMaster: 'Đặt phòng Master',
    groupCheckout: 'Trả phòng đoàn',
    payment: 'Thanh toán',
    refund: 'Hoàn thành',
    invoice: 'Hóa đơn',
    setDateEqualComeDate: 'Đặt ngày = ngày đến',
    setDateEqualDepartDate: 'Đặt ngày = ngày đi',
    debtAccount: 'Tài khoản công nợ',
    transferDebt: 'Chuyển công nợ',
    debtAccountNumber: 'Số hóa đơn công nợ',
    resetFilter: 'Xóa Filter',
    addPackageGroup: 'Thêm nhóm gói',
    modifyPackageGroup: 'Sửa nhóm gói',
    deletePackageGroup: 'Xóa nhóm gói',
    note: 'Chú thích',
    exportPdf: 'Xuất PDF',
    exportExcel: 'Xuất Excel',
    select: 'Chọn',
    transfer: 'Chuyển',
    showAll: 'Hiển thị hết',
    apply: 'Áp dụng',
    unApply: 'Bỏ áp dụng',
    close: 'Đóng',
    changePriceOfRoomLevel: 'Sửa giá hạng phòng',
    addPromotion: 'Thêm khuyến mại',
    modifyPromotion: 'Cập nhật khuyến mại',
    deletePromotion: 'Xóa khuyến mại',
    changePeopleNum: 'Thay đổi số lượng người',
    confirm: 'Xác nhận'
  }
}
